import axios from 'axios'

import {
  apiUrl,
  oAuthClientId,
  oAuthClientSecret,
  requestTimeout,
} from '@/data/appConfig'
import { logger } from '@/sdk/oauth'

export default function fetchUserToken(email: string, password: string) {
  logger('fetchUserToken %s, %s', email, password)

  /** @type {string} a url-encoded string of parameters for the request */
  const requestPayload = [
    `username=${encodeURIComponent(email)}`,
    `password=${encodeURIComponent(password)}`,
    `client_id=${oAuthClientId}`,
    `client_secret=${oAuthClientSecret}`,
    'grant_type=password',
    'scope=customer',
  ].join('&')

  return axios.post(`${apiUrl}/auth/token`, requestPayload, {
    timeout: requestTimeout,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  })
}
